import { useI18n } from '@ecom/i18n';
import { type ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

import { NAV_ITEMS } from './nav';

import { cn } from '@/lib/cn';
import { useSession } from '@/lib/session';

export function Sidebar(): ReactElement {
  const { t } = useI18n();
  const { roles } = useSession();
  const items = NAV_ITEMS.filter(
    (item) => item.onlyFor === undefined || roles.includes(item.onlyFor),
  );
  return (
    <aside className="hidden w-64 shrink-0 flex-col border-e border-line bg-surface md:flex">
      <div className="flex items-center gap-2 px-5 py-5">
        <span
          className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent font-display text-lg font-bold text-white"
          aria-hidden="true"
        >
          S
        </span>
        <div className="leading-tight">
          <p className="font-display text-base font-bold text-ink">{t('merchant.sidebar.brand')}</p>
          <p className="text-xs text-inkFaint">{t('admin.sidebar.subtitle')}</p>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 pb-4" aria-label={t('merchant.sidebar.navLabel')}>
        <ul className="flex flex-col gap-0.5">
          {items.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'flex items-center justify-between rounded-md px-2.5 py-2 text-sm font-medium text-inkSoft transition-colors hover:bg-surfaceHover hover:text-ink',
                    isActive && 'bg-accentSoft text-accentInk hover:bg-accentSoft',
                  )
                }
                end
              >
                {t(item.labelKey)}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}
